import { ResponsiveBar } from '@nivo/bar'
import { Spinner } from '@ui/components/loaders'
import { AttributeGroup } from '@ui/interfaces'

interface AttributeGraphGroupProps {
  attributeGroupData: AttributeGroup[]
  handleClick?: ({ name, value }: { name: string; value: string }) => void
  loading: boolean
}

export const AttributeGraphGroup = ({ attributeGroupData, handleClick, loading }: AttributeGraphGroupProps) => {
  return (
    <div className="flex h-full w-full items-center justify-center border-t border-gray-200">
      {loading ? (
        <div className="flex h-[calc(100vh-8.6rem)] w-full items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <div className="flex h-full max-h-[calc(100vh-8.6rem)] w-full flex-col divide-y overflow-y-auto">
          {attributeGroupData.map((attributeGroup, index) => {
            return (
              <div key={index} className="flex h-full flex-col items-start justify-center px-12 py-2.5">
                <div className="flex h-64 w-full flex-row items-center justify-start">
                  <h2 className="w-[350px] truncate text-lg font-normal text-gray-800">{attributeGroup.name}</h2>

                  {/* TODO: Turn this into a component */}
                  <ResponsiveBar
                    data={attributeGroup.values}
                    keys={['count']}
                    indexBy="value"
                    margin={{ top: 15, right: 200, bottom: 45, left: 85 }}
                    padding={0.1}
                    colors={{ scheme: 'nivo' }}
                    colorBy={'indexValue'}
                    borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                    theme={{
                      text: {
                        fontSize: 14,
                      },
                      axis: {
                        legend: {
                          text: {
                            fontSize: 14,
                            fontWeight: 600,
                          },
                        },
                      },
                      legends: {
                        text: {
                          fontSize: 14,
                        },
                      },
                    }}
                    axisBottom={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: 'Attribute Value',
                      legendPosition: 'middle',
                      legendOffset: 35,
                      truncateTickAt: window.innerWidth / 195,
                    }}
                    axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: 'Count',
                      legendPosition: 'middle',
                      legendOffset: -70,
                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                    enableTotals={true}
                    totalsOffset={5}
                    enableLabel={false}
                    onClick={(data) => {
                      if (handleClick) {
                        handleClick({ name: attributeGroup.name, value: data.indexValue as string })
                      }
                    }}
                    legends={[
                      {
                        dataFrom: 'indexes',
                        anchor: 'bottom-right',
                        direction: 'column',
                        justify: false,
                        translateX: 140,
                        translateY: 10,
                        itemsSpacing: 1.5,
                        itemWidth: 100,
                        itemHeight: 20,
                        itemDirection: 'left-to-right',
                        itemOpacity: 0.85,
                        symbolSize: 20,
                        onClick: (data) => {
                          if (handleClick) {
                            handleClick({ name: attributeGroup.name, value: data.id as string })
                          }
                        },
                        effects: [
                          {
                            on: 'hover',
                            style: {
                              itemOpacity: 1,
                            },
                          },
                        ],
                      },
                    ]}
                  />
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
